import React from "react";
import { Box, Typography } from "@mui/material";

const YOUTUBE_PATTERNS = [
    /(?:youtube\.com\/watch\?.*v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/,
];

const getYoutubeEmbedId = (url) => {
    for (const pattern of YOUTUBE_PATTERNS) {
        const match = url.match(pattern);
        if (match) return match[1];
    }
    return null;
};

const isYoutubeUrl = (url) => {
    return /youtube\.com|youtu\.be/.test(url);
};

/**
 * VideoPreview
 * Props:
 *   url       {string}  - YouTube URL or direct video URL
 *   title     {string}  - Accessible title (optional)
 *   width     {number}  - Player width in px (default 296)
 *   height    {number}  - Player height in px (default 166)
 *   showUrl   {boolean} - Show the URL below the player (default true)
 */
export default function VideoPreview({ url, title = "video", width = 296, height = 166, showUrl = true }) {
    if (!url) return null;

    const embedId = isYoutubeUrl(url) ? getYoutubeEmbedId(url) : null;

    return (
        <Box>
            {embedId ? (
                <iframe
                    width={width}
                    height={height}
                    src={`https://www.youtube.com/embed/${embedId}`}
                    title={title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            ) : (
                <video
                    width={width}
                    height={height}
                    controls
                    title={title}
                    style={{ display: "block" }}
                >
                    <source src={url} />
                </video>
            )}
            {showUrl && (
                <Typography align="left" variant="body2" sx={{ mt: 0.5, wordBreak: "break-all" }}>
                    {url}
                </Typography>
            )}
        </Box>
    );
}
